module.exports = __webpack_public_path__ + "static/media/password@2x.8720b2e9.png";